//FUNZIONE BOOTSTRAP PER CONTROLLO CAMPI AL SUBMIT
(function() {
  'use strict';
  window.addEventListener('load', function() {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function(form) {
      form.addEventListener('submit', function(event) {

        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (form.checkValidity() === true) {
        $('.wrapSpinner').fadeIn('slow');
        }

        form.classList.add('was-validated');
        console.log("sto");

        $('html, body').animate({
          scrollTop: $('.invalid-feedback:visible:first').offset().top - 280
        }, 1000);

        setTimeout(function() {
          $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
        }, 1000);

        setTimeout(function() {
          $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
        }, 3000);

      }, false);
    });
  }, false);
})();
//FUNZIONE PER ABILITARE I TOOLTIP
$(function() {
  $('[data-toggle="tooltip"]').tooltip();
});

//Funzione per mostrare o nascondere tipo di form
$(document).on('click', '#moduloRidotto', function(event) {
  event.preventDefault();
  $('.hideFormRidotto').fadeIn('slow');
  $('.hideFormCompleto').hide();
  if ($(window).width() > 768) {
    $('html, body').animate({
      scrollTop: $('.formBreve').offset().top - 225
    }, 1000);
  } else{
    $('html, body').animate({
      scrollTop: $('.formBreve').offset().top - 210
    }, 1000);
  }
});
//Funzione per mostrare o nascondere tipo di form
$(document).on('click', '#moduloIntero', function(event) {
  event.preventDefault();
  $('.hideFormCompleto').fadeIn('slow');
  $('.hideFormRidotto').hide();
  if ($(window).width() > 768) {
    $('html, body').animate({
      scrollTop: $('.formBreve').offset().top + 450
    }, 1000);
  } else{
    $('html, body').animate({
      scrollTop: $('.formBreve').offset().top + 570
    }, 1000);
  }
});

/* CONTROLLO SE I VALUE DEL FORM SIANO PREPOPOLATI IN TAL CASO AGGIUNGO VALID-FEEDBACK */
$('.formBreve :input').each(function(index, el) {
  var value = $(el).val();
  if ($(window).width() > 768) {
    if (value != "") {
      $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
    }
  }
});
$('.formLungo :input').each(function(index, el) {
  var value = $(el).val();
  if ($(window).width() > 768) {
    if (value != "") {
      $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
    }
  }
});
/* QUI CONTROLLO LA SEZIONE TIPOLOGIA CLIENTE CONFRONTO IL VALORE DELLE SELECT CON
   I CAMPI CHE SELEZIONERA' L'UTENTE E ABILITO O DISABILITO I CAMPI DELLA SEZIONE INFO AZIENDA
*/$(document).on('change', '.clienteFormDue', function(event) {
  event.preventDefault();

  if ($(this).val() == 'DITTE-INDIVIDUALI') {
         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').show();

       }
       else if ($(this).val() == 'PERSONE-FISICHE-PRIVATI') {

         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').hide();
         $('#infoAzienda').find("input, select").removeAttr('required');

       }
       else if ($(this).val() == 'PENSIONATI') {

         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').hide();
         $('#infoAzienda').find("input, select").removeAttr('required');

       }
       else if ($(this).val() == 'SOCIETA-DI-CAPITALI') {

         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').show();
         $('.nomeAzienda').show();
         $('#infoAzienda').find("input, select").attr('required', 'required');

       }
       else if ($(this).val() == 'SOCIETA-DI-PERSONE') {

         console.log('societa di persone');
         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').show();
         $('.nomeAzienda').show();
         $('#infoAzienda').find("input, select").attr('required', 'required');

       }
       else if ($(this).val() == 'LIBERI-PROFESSIONISTI') {

         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').show();
         $('.nomeAzienda').hide();
         $('#infoAzienda').find("input, select").attr('required', 'required');
         $('#infoAzienda').find("input, select").removeAttr('required');
       }
       else if ($(this).val() == 'ENTI-PUBBLICI') {

         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').show();
         $('.nomeAzienda').show();
         $('#infoAzienda').find("input, select").prop('required', 'required');

       }
       else if ($(this).val() == 'ASSOCIAZIONE-ENTE-FONDAZIONE') {

         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').show();
         $('.nomeAzienda').show();
         $('#infoAzienda').find("input, select").attr('required', 'required');

       }
       else if ($(this).val() == 'STUDI-ASSOCIATI-ASSOCIAZIONI-ARTISTI-LIB-PROF') {

         $(this).addClass('is-valid');
         if ($(window).width() > 768) {
           $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
         }
         $('#infoAzienda').show();
         $('.nomeAzienda').show();
         $('#infoAzienda').find("input, select").attr('required', 'required');

       } else if ($(this).val() == "") {
         $('.clienteFormDue ~ .valid-feedback').hide();
         $('#infoAzienda').find("input, select").attr('required', 'required');
       }
});
/* AL CHANGE DEi FORM CONTROLLO SE I CAMPI SIA COMPILATI IN MANIERA CORRETTA E A SECONDA DELL'ESITO MOSTRO MESSAGGI */
$('.formLungo :input').not('[type=radio]').not('[type=checkbox]').on('change',  function(event) {
  console.log('sono qui');
  event.preventDefault();
  var name = $(this).attr('name');
  var valore = $(this).val();
  if (name == "cf") {
    if (valore.match(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/)) {
      console.log(valore.length);
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'piva') {
    if (valore.match(/^[0-9]{11}$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'cellulare' || name == "telefonofisso") {
    if (valore.match(/^[0-9]*\d$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'emailAnag' || name == "emailAnagSec") {
    if (valore.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else if (valore == "") {
      $(this).removeClass('is-valid');
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'cap') {
    if (valore.match(/^\d{5}$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else {
    $(this).addClass('is-valid');
    if ($(window).width() > 768) {
      $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
    }
  }

});
$('.formBreve :input').not('[type=radio]').not('[type=checkbox]').on('change',  function(event) {
  console.log('sono qui');
  event.preventDefault();
  var name = $(this).attr('name');
  var valore = $(this).val();
  if (name == "cf") {
    if (valore.match(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/)) {
      console.log(valore.length);
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'piva') {
    if (valore.match(/^[0-9]{11}$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'cellulare' || name == "telefonofisso") {
    if (valore.match(/^[0-9]*\d$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'emailAnag' || name == "emailAnagSec") {
    if (valore.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else if (valore == "") {
      $(this).removeClass('is-valid');
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else if (name == 'cap') {
    if (valore.match(/^\d{5}$/)) {
      $(this).addClass('is-valid');
      $(this).removeClass('is-invalid');
      if ($(window).width() > 768) {
        $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
      }
    } else {
      $(this).removeClass('is-valid');
      $(this).addClass('is-invalid');
      $('.invalid-feedback:visible:first').parent().addClass('animated pulse');
      setTimeout(function() {
        $('.invalid-feedback:visible:first').parent().removeClass('animated pulse');
      }, 3000);
    }
  }
  else {
    $(this).addClass('is-valid');
    if ($(window).width() > 768) {
      $(this).after('<div class="valid-feedback"><i class="fa fa-check-circle"></i></div>');
    }
  }

});
